const URL_BASE = "/news/videos/";
const COJP_BASE = "/jp/news/videos/";

export function generateVodUrl(
    storySlug: string,
    isCOJP: boolean = false
): string {
    return `${isCOJP ? COJP_BASE : URL_BASE}${storySlug}`;
}
